/**
 * @generated SignedSource<<38089e6a3032ad063774895a88f2f73d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MembershipPlanIncludedProductsFragment$data = {
  readonly id: string;
  readonly membershipBenefits: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly product: {
          readonly " $fragmentSpreads": FragmentRefs<"MembershipPlanExperienceDetailsFragment">;
        } | null;
      };
    }>;
  } | null;
  readonly " $fragmentType": "MembershipPlanIncludedProductsFragment";
};
export type MembershipPlanIncludedProductsFragment$key = {
  readonly " $data"?: MembershipPlanIncludedProductsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MembershipPlanIncludedProductsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hideDrafts"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hideNonPublic"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MembershipPlanIncludedProductsFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "hideDrafts",
          "variableName": "hideDrafts"
        },
        {
          "kind": "Variable",
          "name": "hideNonPublic",
          "variableName": "hideNonPublic"
        }
      ],
      "concreteType": "MembershipBenefitNodeConnection",
      "kind": "LinkedField",
      "name": "membershipBenefits",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MembershipBenefitNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MembershipBenefit",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Product",
                  "kind": "LinkedField",
                  "name": "product",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "MembershipPlanExperienceDetailsFragment"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};
})();

(node as any).hash = "5a0e8ef4a45375fffa6827115ffe02fd";

export default node;
